import { gql } from '@apollo/client';

export const COMPANY_UPLOAD_STORAGE_TRANSCRIBE_ERROR = gql`
  query UploadsFailed {
    uploadsFailed {
      id
      createdAt
      user {
        profile {
          firstName
          lastName
        }
      }
      project {
        name
        company {
          name
        }
      }
      testSession {
        id
        status
        videoKey
      }
    }
  }
`;
